import { UploadedFile } from "@cca/components";
import { DownloadFileResponse } from "@core/types";
import { bindAll } from "@core/utils";
import { NavigateFunction } from "react-router-dom";

import AxiosService, { type TokenHandlers } from "./axiosService";

export default class LearnerResponseFileService extends AxiosService {
  constructor(tokenHandlers: TokenHandlers, navigateTo: NavigateFunction) {
    super("learner-response-files", tokenHandlers, navigateTo);
    bindAll(this);
  }

  public downloadFile = (id: number): Promise<DownloadFileResponse> =>
    this.nativeGet<DownloadFileResponse>(`${id}`).then((r) => r.data);

  public deleteFile = (id: number) => this.delete(`${id}`);

  public async saveFile(
    file: UploadedFile,
    fileKind: string,
    onProgress?: (progress: number) => void,
  ): Promise<number | null> {
    const formData = new FormData();
    formData.append("file", file as Blob);
    formData.append("fileKind", fileKind);

    return this.post<number, unknown>("", formData, {
      headers: { "Content-Type": "multipart/form-data" },
      onUploadProgress: (progressEvent) => {
        if (progressEvent.total && onProgress) {
          const percentCompleted = Math.round(
            (progressEvent.loaded * 100) / progressEvent.total,
          );
          onProgress(percentCompleted);
        }
      },
    });
  }
}
